// JOBE-0044.13: schema-driven preview-card driver registry. Component-
// registry pattern per the spec's Decisions block — a per-kind preview
// component registers against a kind slug; unregistered kinds fall back
// to <GenericAttributesPreview>. Sub-kinds of document (briefing,
// report, statement, …) inherit DocumentPreview via the
// `structuralShape: document` consult on EntityTypesContext (canonical
// tri-state shape per JOBE-0044.6: { status, types, error }).
//
// Adding a new per-kind preview is a two-line change: add the
// component file under `previews/`, add the registry entry below.

import { DocumentPreview } from './DocumentPreview.jsx';

const registry = new Map([
  ['document', DocumentPreview],
]);

// pickPreview returns the per-kind React component for `entity`, or
// `null` to signal the generic-attribute fallback. Lookup order:
//   1. Exact `entity.kind` match in the registry (always wins).
//   2. Structural-shape consult on EntityTypesContext when the
//      provider reports `ready` — any kind whose registry entry
//      carries `structuralShape: document` gets DocumentPreview.
//      `loading` / `error` context values fall through to `null`
//      (graceful — no spinner, no flash; the inspector upgrades to
//      the per-kind preview once the provider reaches `ready`).
//   3. Otherwise `null` (caller renders GenericAttributesPreview).
export function pickPreview(entity, entityTypesCtx) {
  if (!entity || !entity.kind) return null;
  if (registry.has(entity.kind)) return registry.get(entity.kind);
  if (!entityTypesCtx || entityTypesCtx.status !== 'ready') return null;
  const types = Array.isArray(entityTypesCtx.types) ? entityTypesCtx.types : [];
  const t = types.find((e) => e && e.kind === entity.kind);
  if (t && t.structuralShape === 'document') return DocumentPreview;
  return null;
}
